module.exports = __webpack_public_path__ + "static/media/bnb.d50bb371.png";